/**
 * This file contains the reducer for the package complete tutorial.
 *
 * The package complete tutorial is the pop up that appears after a student
 * completes a package to congratulate them and remind them there are other
 * packages they can do.
 */

import { fromJS } from 'immutable';

import { RESET_TUTORIALS } from '../actions';

import {
    DISMISS_PACKAGE_COMPLETE_TUTORIAL,
    TRIGGER_PACKAGE_COMPLETE_TUTORIAL,
} from '../tutorial-actions/package-complete';

export const PACKAGE_COMPLETE_TUTORIAL_KEY = 'packageCompleteTutorial';

const INITIAL_STATE = fromJS({
    // NOTE: The package complete tutorial is never "completed", but will
    // switch to be active whenever a compulsory package is completed.
    completed: false,
    active: false,
    state: null,
});

export function packageCompleteTutorialReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case RESET_TUTORIALS:
            return INITIAL_STATE;

        case TRIGGER_PACKAGE_COMPLETE_TUTORIAL:
            return state.set('active', true).set(
                'state',
                fromJS({
                    completedPackageDueDate: action.completedPackageDueDate,
                    nextIncompletePackageID: action.nextIncompletePackageID,
                }),
            );

        case DISMISS_PACKAGE_COMPLETE_TUTORIAL:
            return state.set('active', false);
    }

    return state;
}
